import { WorkActivity } from '@/services/types/work-activity.types';
import { BudgetMemberEntry } from '@/services/types/budgets.types';

export const getSubmitterHourlyRate = (
  workActivity: WorkActivity,
  budgetMembers: BudgetMemberEntry[] = []
): number | null => {
  const member = budgetMembers.find((entry) => entry._id === workActivity.creator.member_id);
  if (member?.hourly_rate != null) {
    return member.hourly_rate;
  }

  const allocationRate = workActivity.allocations?.find((allocation) => allocation.hourly_rate != null)?.hourly_rate;
  if (allocationRate != null) {
    return allocationRate;
  }

  return null;
};

export const isWorkActivityCreator = (
  workActivity: WorkActivity | null | undefined,
  currentMember?: { _id?: string; user_id?: string } | null,
  currentUser?: { id?: string } | null
): boolean => {
  if (!workActivity) {
    return false;
  }

  if (currentMember?._id && workActivity.creator.member_id === currentMember._id) {
    return true;
  }

  if (currentMember?.user_id && workActivity.creator.user_id === currentMember.user_id) {
    return true;
  }

  if (currentUser?.id && workActivity.creator.user_id === currentUser.id) {
    return true;
  }

  return false;
};
